import React from 'react';
import './Nopagefound.css'

const Nopagefound = () => {
    return (
        <div className='nopage-container'>
            <h1>404</h1>
            <h2>No Page Found</h2>
        </div>
    );
};

export default Nopagefound;